var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10117_41613",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#F4F4F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10117_41613)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 25,
    width: 78,
    height: 109,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 70,
    width: 61,
    height: 8,
    rx: 4,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 82,
    width: 28,
    height: 8,
    rx: 4,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 82,
    width: 29,
    height: 8,
    rx: 4,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 50,
    width: 62,
    height: 8,
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 50,
    width: 29,
    height: 8,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 50,
    width: 18,
    height: 8,
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 27C21 25.8954 21.8954 25 23 25H97C98.1046 25 99 25.8954 99 27V38H21V27Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.5,
    cy: 31.5,
    r: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.5,
    cy: 31.5,
    r: 2.5,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState1);
export default __webpack_public_path__ + "static/media/EmptyState1.c3665d5ae3917843e54e83abe955bbd8.svg";
export { ForwardRef as ReactComponent };